// NEED TO MOVE CTAS TO REACT
import AskQuestionToAgentFormContainer from '@react/cta/components/AskQuestionToAgentFormContainer';
import { useEvents } from '@react/services/events';
import { eventNames } from '@react/services/events';
import Modal, {
  HeaderWithClose,
  ModalBody,
} from '@react/shared/components/NewModal';
import { Button } from '@react/system';
import { AGENT_ASK_QUESTIONS } from '@sly/core/constants/actionTypes';
import { func, string } from 'proptypes';
import React, { useState } from 'react';

/**
 * @param {{
 *   heading?: string,
 *   agentSlug?: string,
 *   onSubmit?: (...args: any[]) => void,
 *   children?: any,
 *   className?: string,
 *   buttonText?: string
 * }} props
 */
function AskAgentQuestionModalButton({
  heading,
  agentSlug,
  onSubmit = () => {},
  children,
  className,
  buttonText,
}) {
  const [showModal, setShowModal] = useState(false);
  const { events } = useEvents();

  const toggleModal = () => {
    const action = showModal ? eventNames.ModalExited : eventNames.ModalShown;
    let category = 'AskAgentQuestion';
    const eventProps = {
      category,
      label: 'get-expert-help',
      location: 'homebase',
    };
    events.track(action, eventProps);
    setShowModal((showModal) => !showModal);
  };

  return (
    <>
      <Button
        className={className}
        onClick={toggleModal}
        eventProps={{
          cta: 'message agent',
          text: buttonText,
          location: 'homebase',
        }}
      >
        {children}
      </Button>
      <Modal isOpen={showModal} onClose={toggleModal}>
        <HeaderWithClose onClose={toggleModal}>{heading}</HeaderWithClose>
        <ModalBody className='p-0'>
          <AskQuestionToAgentFormContainer
            actionType={AGENT_ASK_QUESTIONS}
            postSubmit={() => {
              toggleModal();
              onSubmit();
            }}
            agentSlug={agentSlug}
            entityId={agentSlug}
          />
        </ModalBody>
      </Modal>
    </>
  );
}

AskAgentQuestionModalButton.propTypes = {
  heading: string,
  agentSlug: string,
  onSubmit: func,
};

export default AskAgentQuestionModalButton;
